export default "__VITE_ASSET___Eb8wcpu__"